import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';

import { CitySidebar_city$key } from '__generated__/CitySidebar_city.graphql';

type Props = {
  city: CitySidebar_city$key;
};

const CitySidebar: FC<Props> = props => {
  const city = useFragment(
    graphql`
      fragment CitySidebar_city on City {
        ...EntitySidebar_entity
      }
    `,
    props.city
  );

  return <EntitySidebar entity={city} />;
};

export default CitySidebar;
